export enum DataParameters {
	REF = 'ref',
	REF_ID = 'ref_id',
	UTM_SOURCE = 'utm_source',
	UTM_UUID = 'utm_uuid',
	UTM_MEDIUM = 'utm_medium',
	UTM_CAMPAIGN = 'utm_campaign',
	UTM_TERM = 'utm_term',
	UTM_CONTENT = 'utm_content',
	REFERRER = 'referrer',
}

export default DataParameters;
